// extracted by mini-css-extract-plugin
export default {"ellipsis":"fP0I4WlaVZMw3FZUdedf","wrapper":"pnV1FxKK7JWmN78kuhlw","spin":"xw1oik3eYw1toSHNWXle"};